<template>
  <div class="cinbox">
    <section id="banner">
      <div class="wrapper" :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"></div>
    </section>
    <section id="breadcrumb">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <router-link :to="{path: '/'}">回首页</router-link>&nbsp;&gt;&nbsp;
        <router-link :to="{path: '/cnews', query: {categoryId: categoryId}}">{{categoryInfo.name}}</router-link>&nbsp;&gt;&nbsp;<a >新闻详情</a>
      </div>
    </section>
    <section id="content">
      <div class="wrapper">
        <div class="date">
          <font style="vertical-align: inherit;">
            <font style="vertical-align: inherit;">{{content.createTime}} |</font>
            <font style="vertical-align: inherit;">{{content.author}}</font>
          </font>
        </div>
        <h1 class="title">
          <font style="vertical-align: inherit;">
            <font style="vertical-align: inherit;">{{content.title}}</font>
          </font>
        </h1>
        <div class="tag" v-if="content.tagName && content.tagName.length > 0">
          <img src="../assets/icon_tag.png" alt />
          <a v-for="(item, index) in content.tagName" :key="index">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">{{item}}</font>
            </font>
            <font style="vertical-align: inherit;" v-if="index !== content.tagName.length - 1">
              <font style="vertical-align: inherit;">，</font>
            </font>
          </a>
          
        </div>
        <div id="uiDiv_desc" class="des" v-html="content.content">
        </div>
        <div class="tag" v-if="content.tagName && content.tagName.length > 0">
          <img src="../assets/icon_tag.png" alt />
          <a v-for="(item, index) in content.tagName" :key="index">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">{{item}}</font>
            </font>
            <font style="vertical-align: inherit;" v-if="index !== content.tagName.length - 1">
              <font style="vertical-align: inherit;">，</font>
            </font>
          </a>
          
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import { getCategoryInfo, getContentInfo } from '@/api/content'
export default {
  name: "",
  data() {
    return {
      msg: "这是我的",
      categoryId: this.$route.query.categoryId,
      id: this.$route.query.id,
      categoryInfo: {},
      content: {}
    };
  },
  methods: {
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then(res => {
        if (res.code !== 200) return
        this.categoryInfo = res.data
        this.categoryInfo.categoryPic = process.env.BASE_API + '/web' + this.categoryInfo.categoryPic
      })
    },
    getContentInfo() {
      getContentInfo(this.id).then(res => {
        if (res.code !== 200) return
        this.content = res.data
      })
    }
  },
  mounted() {
    this.getBanner()
    this.getContentInfo()
  },
};
</script>

<style scoped >
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  background: url(../assets/20170519-17081289.jpg) center top no-repeat;
  background-size: 100% auto;
}
#banner .wrapper {
  background-size: auto 100% !important;
}
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper {
    height: 140px;
  }
}
@media screen and (max-width: 1300px) {
  section .wrapper {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  #banner .wrapper {
    background-size: auto 100%;
  }
}

section#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
@media screen and (max-width: 760px) {
  section#breadcrumb .wrapper {
    padding: 10px;
    font-size: 12px;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 1120px){
section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
}}
#content .wrapper {
    width: 1100px;
    padding: 40px 20px;
    text-align: left;
    box-sizing: border-box;
}
#content .wrapper .title {
    font-weight: normal;
    font-size: 24px;
    color: #146cbd;
    padding: 10px 0 30px;
    font-family: 'LatoWeb';
}
#content .wrapper .tag a {
    color: #15262e;
}
#content .wrapper .des {
    margin-top: 30px;
    padding: 30px 0;
    border-top: 1px #CCC solid;
    line-height: 32px;
    font-size: 18px;
    font-family: 'LatoWebLight';
    color: #666;
}
#content .wrapper .des p{
    margin:20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/cn_detail.vue